import request from '#/utils/request';
import { withFmsActor } from '#/api/fmsMgmt/fmsActorConfig';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * POST `/fms/vouchers/{id}/cancellation`：`ACTIVE → CANCELLED`。
 * cancelReason 必填；已被請款單引用回 409 VOUCHER_IN_USE。
 */
export async function cancelVoucher(id, { cancelReason }) {
  const { data: raw } = await request.post(
    `/fms/vouchers/${id}/cancellation`,
    keysToSnake({ cancelReason }),
    withFmsActor(),
  );
  return parseVer4DetailResponse(raw);
}
